// Modules
import styled from 'styled-components'
import breakPoint from 'theme/breakpoints'

export const Container = styled.div`
    display: flex;
    flex: 1;
    height: 100vh;
    flex-direction: column;

    ${breakPoint.desktop} {
        flex-direction: row;
    }
`

export const ContainerContent = styled.section`
    display: flex;
    flex: 3;
    justify-content: center;
    align-items: flex-start;
    padding: 0 1rem;
    background: rgb(0, 55, 255);
    background: linear-gradient(180deg, rgba(0, 55, 255, 1) 25%, rgba(255, 255, 255, 1) 25%);

    ${breakPoint.desktop} {
        display: flex;
        flex: 3;
        justify-content: center;
        align-items: center;
        padding: 0 1rem;
        background: #fff;
    }
`

export const ContainerPage = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    max-width: 434px;
    justify-self: center;
    flex: 1;
    border-radius: 0.5rem;
    background-color: #fff;
    padding: 2rem 1.5rem 1.5rem;
    box-shadow: 0px 8px 24px 0px rgba(22, 22, 22, 0.08), 0px 4px 4px 0px rgba(22, 22, 22, 0.04);

    ${breakPoint.desktop} {
        display: flex;
        flex-direction: column;
        align-self: center;
        justify-self: center;
        flex: 1;
        max-width: 25.5rem;
        box-shadow: none;
    }
`

export const CustomImage = styled.img`
    height: 24px;
    max-width: fit-content;

    ${breakPoint.desktop} {
        height: 32px;
    }
`
